import React from 'react';
import PropTypes from 'prop-types';

import RadioButton from '../../RadioButton';
import styles from './RadioList.module.css';

const propTypes = {
  containingTab: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  itemDisplayText: PropTypes.string.isRequired,
  itemValue: PropTypes.string.isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
  onItemSelect: PropTypes.func.isRequired,
};

function RadioListItem({
  containingTab,
  identifier,
  isSelected,
  isDisabled,
  itemDisplayText,
  itemValue,
  onAccordionStateChange,
  onItemSelect,
}) {
  const handleSelect = (event) => {
    if (!isSelected) {
      onAccordionStateChange(containingTab, identifier, onItemSelect(itemValue));
    }
  };

  const additionalProps = {};
  if (isDisabled) {
    additionalProps.disabled = 'disabled';
  }
  if (isSelected) {
    additionalProps.checked = true;
  }

  return (
    <div>
      <RadioButton
        {...additionalProps}
        className={styles['radio-item']}
        label={itemDisplayText}
        name={identifier}
        onChange={handleSelect}
        value={itemValue}
      />
    </div>
  );
}

RadioListItem.propTypes = propTypes;

export default RadioListItem;
